import { Navigate, useLocation } from 'react-router-dom';
import { useTenantAuth, useCurrentEmployee } from '@/modules/tenant/hooks/useTenantAuth';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@marine/ui/card';

interface TenantProtectedRouteProps {
  children: React.ReactNode;
}

export function TenantProtectedRoute({ children }: TenantProtectedRouteProps) {
  const { isAuthenticated, isLoading: isStoreLoading } = useTenantAuth();
  const { isLoading: isQueryLoading } = useCurrentEmployee();
  const location = useLocation();
  
  const isLoading = isStoreLoading || (isAuthenticated && isQueryLoading);

  // Show loading spinner while checking auth status
  if (isLoading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-background px-6 py-10">
        <Card className="w-full max-w-sm">
          <CardContent className="p-6">
            <div className="flex flex-col items-center gap-3 text-center">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                <Loader2 className="h-5 w-5 animate-spin" />
              </div>
              <div className="text-sm font-medium">Loading workspace</div>
              <div className="text-xs text-muted-foreground">Checking your session and permissions.</div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Render protected content
  return <>{children}</>;
}
